<template>
    <div class="space-y-12">
        <select-dropdown
            v-model="filterFields.filterGroups"
            :auto-translate="false"
            :multiple="true"
            :searchable="true"
            :loading="fetching"
            :options="filterGroups"
            :placeholder="$t('form.dropdown.placeholder')"
            remove-icon
            can-select-all
            :input-label="$t('analytics.filter_groups.single')"
        />

        <template v-if="!!filterFields.filterGroups?.length">
            <select-dropdown
                v-model="filterFields.filterGroupValues"
                :auto-translate="false"
                :multiple="true"
                :searchable="true"
                :loading="fetching"
                :options="filterGroupValues"
                :placeholder="$t('form.dropdown.placeholder')"
                remove-icon
                can-select-all
                :input-label="$t('analytics.filter_groups.values')"
            />
        </template>
    </div>
</template>

<script>
import SelectDropdown from "../forms/SelectDropdown";
import FilterGroup from "../../models/FilterGroup";
import * as FilterGroupService from '../../services/FilterGroupService';
import {mapState} from "pinia";
import {useRepo} from 'pinia-orm';
import {useMainStore} from '../../state/store';
import {normalizeJson} from "../../../shared/helpers";

export default {
    name: 'FilterJobLocations',
    components: {
        SelectDropdown,
    },
    props: {
        filterFields: {type: Object},
    },
    data() {
        return {
            fetching: true,
            selectedFilterGroups: [],
        }
    },
    computed: {
        ...mapState(useMainStore, ['locale']),
        filterGroups() {
            return useRepo(FilterGroup).all().map(val => ({
                value: val.id,
                label: val.title[this.locale],
            }));
        },
        filterGroupValues() {
            let filters = this.filterGroups.filter(group => this.filterFields.filterGroups?.includes(group.value))
                    .map(group => useRepo(FilterGroup).find(group.value).filters)
                    .flat()
                    .map(val => ({
                        value: val.id,
                        label: val.title[this.locale],
                    }));

            // add the filterGroup name to the label of the filter
            return filters.map(filter => {
                let filterGroup = useRepo(FilterGroup).all().find(group => group.filters.find(f => f.id === filter.value)),
                    filterGroupTitle = filterGroup.title[this.locale] ?? this.$t('general.missing_translation'),
                    filterGroupLabel = filter.label ?? this.$t('general.missing_translation');
                return {
                    value: filter.value,
                    label: `${filterGroupTitle} - ${filterGroupLabel}`
                }
            })
        }
    },
    watch: {
        'filterFields.filterGroups': function (val) {
            if (!val.length) {
                this.filterFields.filterGroupValues = [];
            }
        }
    },
    mounted() {
        FilterGroupService.index(true).then(({data}) => {
            useRepo(FilterGroup).save(normalizeJson(data))
        }).then(() => this.fetching = false)
    }
}
</script>
